import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import MobileView from './MobileView';
import DesktopView from './DesktopView';
import TabletView from './TabletView';

export default function Header(props) {
  const { className } = props;

  const { isPhone, isTablet } = useSelector(state => state.responsive);

  let View = DesktopView;

  if (isTablet) {
    View = TabletView;
  }

  if (isPhone) {
    View = MobileView;
  }

  return <View className={className} />;
}

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
};
